<template>
  <v-avatar :size="size" color="primary">
    <v-img v-if="src" :src="src" :alt="alt" />
    <v-icon color="white" v-else>mdi-account</v-icon>
  </v-avatar>
</template>
<script>
export default {
  name: "AvatarBroker",
  props: {
    src: String,
    alt: String,
    size: {
      type: [String, Number],
      default: "30"
    }
  }
};
</script>
